"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function ($) {
  $.fn.updateAllLawyer = function (callback) {
    var callback = callback || function () {};

    $(this).on('submit', function (e) {
      var _dataForm;

      var id = $('.js-lawyer').data('lawyer'),
          urlApi = '/api/v1/lawyers/' + id;
      e.preventDefault(); // Specialities

      var specsArr = [],
          spec_inputs = $('.js-input-spec');
      spec_inputs.each(function () {
        var dataID = $(this).attr('data-id');

        if (dataID && $(this).val() != '') {
          specsArr.push(parseInt(dataID));
        }
      }); // Langues

      var langArr = [];
      $('.js-language').each(function () {
        if ($(this).prop('checked') == true) {
          langArr.push(parseInt($(this).attr('id')));
        }
      }); // Main Firm

      if ($('.js-main-firm').attr('data-id')) {
        var main_firm = $('.js-main-firm').attr('data-id');
      } else {
        var main_firm = [];
      } // Secondary firms


      var second_firms = [];
      $('.js-secondary-firm').each(function () {
        var id = $(this).attr('data-id');
        second_firms.push(parseInt(id));
      }); // Clubs

      var selectClub = $('.js-clubs'),
          clubsArr = [];
      selectClub.each(function () {
        var id = $(this).next('.js-dropsel-btn').data('id');
        clubsArr.push(id);
      }); // Skills

      var skills = $('.js-skill-checkbox'),
          skillsArray = [],
          problematics = $('.js-problematic'),
          problematicsArray = [];
      skills.each(function () {
        skillsArray.push(parseInt($(this).val()));
      });
      problematics.each(function () {
        if ($(this).prop('checked') == true) {
          problematicsArray.push(parseInt($(this).val()));
        }
      }); // Bars

      var barsArr = [],
          bar = $('.js-input-bar');
      bar.each(function () {
        var id = $(this).attr('data-id');
        barsArr.push(id);
      });

      if ($('#sworn_date').val()) {
        var sworn_date = $('#sworn_date').val();
      } else {
        var sworn_date = null;
      }

      if ($('#youtube_url').val()) {
        var youtube_id = $('#youtube_url').data('video-id');
      } else {
        var youtube_id = "";
      }

      var dataForm = (_dataForm = {
        "first_name": $('#first_name').val(),
        "last_name": $('#last_name').val(),
        "specialities": specsArr,
        "spoken_languages": langArr,
        "main_law_firm": main_firm,
        "secondary_law_firm": second_firms,
        "function": $('#function').val(),
        "previous_function": $('#previous_function').val(),
        "clubs": clubsArr,
        "competences": skillsArray,
        "problematics": problematicsArray,
        "vow": sworn_date,
        "other": CKEDITOR.instances.more_cv.getData(),
        "video_url": youtube_id,
        "fees": CKEDITOR.instances.fees.getData(),
        "share_fee": $('#show_fees').prop('checked'),
        "bar": $('#bar').data('id'),
        "position": parseInt($('#status_lawyer').find('option:selected').val())
      }, _defineProperty(_dataForm, "function", $('#function').val()), _defineProperty(_dataForm, "previous_function", $('#previous_function').val()), _defineProperty(_dataForm, "description", CKEDITOR.instances.description.getData()), _defineProperty(_dataForm, "additional_info", CKEDITOR.instances.additional_info.getData()), _defineProperty(_dataForm, "hobbies", CKEDITOR.instances.hobbies.getData()), _defineProperty(_dataForm, "contact_phone", $('#contact_phone').prop('checked')), _defineProperty(_dataForm, "contact_mail", $('#contact_mail').prop('checked')), _defineProperty(_dataForm, "phone_number", $('#phone_number').val()), _defineProperty(_dataForm, "direct_phone_number", $('#direct_phone').val()), _defineProperty(_dataForm, "mobile_phone_number", $('#mobile_phone').val()), _defineProperty(_dataForm, "share_mail", $('#share_mail').prop('checked')), _defineProperty(_dataForm, "share_phone", $('#share_phone').prop('checked')), _defineProperty(_dataForm, "share_direct_phone", $('#share_direct_phone').prop('checked')), _defineProperty(_dataForm, "share_mobile_phone", $('#share_mobile_phone').prop('checked')), _defineProperty(_dataForm, "bars", barsArr), _dataForm);
      $.ajax({
        url: '/api/v1/lawyers/' + $('.js-lawyer').data('lawyer'),
        data: JSON.stringify(dataForm),
        contentType: 'application/json',
        method: 'PUT',
        headers: {
          'Accept-Language': languageCode
        },
        success: function success(response) {
          $('.js-btn-submit').removeClass('Btn--gradient-primary').addClass('Btn--gray-light');
          callback();
        },
        error: function error(_error) {
          console.log(_error);
          var errors = _error.responseJSON;
          new Alert().error();

          for (_error in errors) {
            if (_error == "bars") {
              var inputs = $('[data-error="' + _error + '"]').find('input');
              inputs.each(function () {
                if ($(this).val() == '') {
                  $(this).parent().parent().addClass('has-error');
                }
              });
            } else if (_error == "secondary_law_firm") {
              var inputs = $('[data-error="' + _error + '"]').find('input');
              inputs.each(function () {
                if ($(this).val() == '') {
                  console.log($(this).parent());
                  $(this).parent().addClass('has-error');
                }
              });
            } else {
              $('[data-error="' + _error + '"]').addClass('has-error');
            }
          }

          var headerH = ($('.js-header').height() + 15) * -1;
          $('.has-error[data-error]').first().velocity("scroll", {
            duration: 750,
            easing: [0.645, 0.045, 0.355, 1.000],
            offset: headerH
          });
        }
      }); // Update youtube

      if ($('#youtube_url').val()) {
        vueAccount.updateYoutube($('#youtube_url').attr('data-video-id'));
      }
    });
  };
})(jQuery);

function updateAllInputs() {
  var postulationsResponse = [];
  var degreeResponse = [];
  var socialResponse = []; // Diplômes

  var degrees = $('.js-degree');

  if (degrees.length > 0) {
    degrees.each(function () {
      var degree_elem = $(this);
      var dataNewDegree = {
        "degree": $(this).find('.js-degree-name').val(),
        "degree_date": $(this).find('.js-degree-date').val(),
        "lawyer": $(this).data('lawyer')
      };

      if ($(this).hasClass('js-new-degree')) {
        var sending_method = 'POST',
            urlApi = '/api/v1/degrees';
      } else {
        var sending_method = 'PATCH',
            urlApi = '/api/v1/degrees/' + $(this).attr('data-id');
      }

      $.ajax({
        url: urlApi,
        data: dataNewDegree,
        method: sending_method,
        success: function success(response) {
          degree_elem.attr('data-id', response.id);
          degree_elem.removeClass('js-new-degree');
          degreeResponse.push(true);
        },
        error: function error(_error2) {
          degreeResponse.push(false);
          console.log(degreeResponse);
          var errors = _error2.responseJSON;
          console.log(_error2);

          for (_error2 in errors) {
            var inputs = $('[data-error="' + _error2 + '"]').find('input');
            inputs.each(function () {
              if ($(this).val() == '') {
                $(this).parent().addClass('has-error');
              }
            });
          }

          var headerH = ($('.js-header').height() + 15) * -1;
          $('.has-error[data-error]').first().velocity("scroll", {
            duration: 750,
            easing: [0.645, 0.045, 0.355, 1.000],
            offset: headerH
          });
        }
      });
    });
  } else {
    degreeResponse.push(true);
  } // Postulations


  var postulations = $('.js-postulation');

  if (postulations.length > 0) {
    postulations.each(function () {
      var dataName = {
        "name": $(this).val(),
        "lawyer": $(this).data('lawyer')
      };

      if ($(this).hasClass('js-new-postulation')) {
        var sending_method = 'POST',
            urlApi = '/api/v1/postulations';
      } else {
        var sending_method = 'PATCH',
            urlApi = '/api/v1/postulations/' + $(this).attr('id');
      }

      $.ajax({
        url: urlApi,
        data: dataName,
        method: sending_method,
        success: function success(response) {
          postulationsResponse.push(true);
        },
        error: function error(_error3) {
          console.log(_error3);
          postulationsResponse.push(false);
          var errors = _error3.responseJSON;
          new Alert().error();

          for (_error3 in errors) {
            var inputs = $('[data-error="' + _error3 + '"]').find('input');
            inputs.each(function () {
              if ($(this).val() == '') {
                $(this).parent().parent().addClass('has-error');
              }
            });
          }

          var headerH = ($('.js-header').height() + 15) * -1;
          $('.has-error[data-error]').first().velocity("scroll", {
            duration: 750,
            easing: [0.645, 0.045, 0.355, 1.000],
            offset: headerH
          });
        }
      });
    });
  } else {
    postulationsResponse.push(true);
  } // Social networks


  var social_inputs = $('.js-social-input');
  social_inputs.each(function () {
    if ($(this).val() != '') {
      if ($(this).data('social-id')) {
        var urlApi = '/api/v1/social_networks/' + $(this).data('social-id'),
            dataForm = {
          "id": $(this).data('social-id'),
          "title": $(this).attr('name'),
          "network": $(this).data('social-network'),
          "url": $(this).val(),
          "lawyer": $(this).data('lawyer'),
          "firm": null
        },
            sending_method = 'PATCH';
      } else {
        var urlApi = '/api/v1/social_networks',
            dataForm = {
          "title": $(this).attr('name'),
          "network": $(this).data('social-network'),
          "url": $(this).val(),
          "lawyer": $(this).data('lawyer'),
          "firm": null
        },
            sending_method = 'POST';
      }

      $.ajax({
        url: urlApi,
        data: dataForm,
        method: sending_method,
        success: function success(response) {
          socialResponse.push(true);
        },
        error: function error(_error4) {
          socialResponse.push(false);
          console.log(_error4);
        }
      });
    } else {
      socialResponse.push(true);
    }
  });
  setTimeout(function () {
    if (postulationsResponse.includes(false) == false && degreeResponse.includes(false) == false && socialResponse.includes(false) == false) {
      $('[data-error]').removeClass('has-error');
      $('.js-notification').addClass('show');
      setTimeout(function () {
        $('.js-notification').removeClass('show');
      }, 3000);
    }
  }, 500);
}

(function ($) {
  $.fn.updateSocialNetworks = function () {
    $(this).on('submit', function (e) {
      e.preventDefault();
      var inputs = $('.js-social-input');
      inputs.each(function () {
        if ($(this).data('social-id')) {
          var urlApi = '/api/v1/social_networks/' + $(this).data('social-id');
          var dataForm = {
            "id": $(this).data('social-id'),
            "title": $(this).attr('name'),
            "network": $(this).data('social-network'),
            "url": $(this).val(),
            "lawyer": $(this).data('lawyer'),
            "firm": null
          };
        } else {
          var urlApi = '/api/v1/social_networks';
          var dataForm = {
            "title": $(this).attr('name'),
            "network": $(this).data('social-network'),
            "url": $(this).val(),
            "lawyer": $(this).data('lawyer'),
            "firm": null
          };
          $.ajax({
            url: urlApi,
            data: dataForm,
            method: 'POST',
            success: function success(response) {
              vueAccount.getLawyer($('.js-lawyer').data('lawyer'));
            },
            error: function error(_error5) {}
          });
        }
      });
      $('.js-notification').addClass('show');
      setTimeout(function () {
        $('.js-notification').removeClass('show');
      }, 2000);
    });
  };
})(jQuery);

(function ($) {
  $.fn.deleteSocialNetworks = function () {
    var that = $(this);
    that.each(function () {
      var id = $(this).prev().data('social-id');
      $(this).on('click', function () {
        var input = $(this).prev();

        if (id) {
          $.ajax({
            url: '/api/v1/social_networks/' + id,
            method: 'DELETE',
            success: function success(response) {
              input.val('');
              $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
            },
            error: function error(_error6) {}
          });
        }
      });
    });
  };
})(jQuery);